import { axiosInstance } from "./config";

export default {
  state: {
    rules: {},
  },
  mutations: {
    Set_rules(state, payload) {
      state.rules = payload;
    },
  },
  actions: {
    async Get_rules({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/rules${payload}`)
        .then(function (data) {
          commit("Set_rules", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_rules(commit, payload) {
      return await axiosInstance
        .post("/rules", payload)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_rules(commit, payload) {
      return await axiosInstance
        .put("/rules/" + payload.id, payload)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Delete_rules(commit, payload) {
      return await axiosInstance
        .delete("/rules/" + payload.id)
        .then(function (data) {
          if (data.status == 204) {
            return { success: true };
          }else {
            return data
          }
        })
        .catch(function (error) {
          return {
            error: error?.response?.data,
          };
        });
    },
  },
  getters: {
    g_rules: (state) => state.rules,
  },
};
